import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide
} from '@material-ui/core'
import { forwardRef } from 'react'

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function CustomDialog({
    title,
    content,
    cancelText,
    forwardText,
    open,
    setOpen,
    forwardFunc
}) {
    const handleClose = () => {
        setOpen(false)
    }

    const handleSuccess = () => {
        setOpen(false)
        forwardFunc()
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {cancelText}
                </Button>
                <Button onClick={handleSuccess} color="primary">
                    {forwardText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
